import ThreadCard from './ThreadCard';

export default ThreadCard;
